module.exports = __webpack_public_path__ + "media/white_logo/sofia-52e42178.png";